// When the guardrails service does not run in the install, a request to it is
// not refused: nothing answers it. That is a fact about the install, said as
// one, never as "not allowed" (01-the-console.md § the words).

import { CODE_NO_SERVICE, isRefusal } from "../../platform/bus.ts";
import { NotAllowed, Notice } from "../../ui/components.tsx";

/** unserved reports whether err says the guardrails service does not run here. */
export function unserved(err: unknown): boolean {
  return isRefusal(err, CODE_NO_SERVICE);
}

/**
 * GuardRefusal shows a failed request to the guardrails service: the plain
 * sentence when the service does not run here, the refusal otherwise.
 */
export function GuardRefusal({ err, what, absent }: { err: unknown; what: string; absent: string }) {
  if (unserved(err)) {
    return <Notice title="Guardrails do not run here yet">{absent}</Notice>;
  }
  return <NotAllowed err={err} what={what} />;
}
